import { jsx as _jsx } from "react/jsx-runtime";
import { Slack as SlackIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { useToasts } from "@air/provider-toast";
import { memo } from "react";
import { useConnectToSlack } from "../hooks/useConnectToSlack";
export const ConnectToSlack = /*#__PURE__*/ memo((param)=>{
    let { board } = param;
    const { connectToSlack } = useConnectToSlack();
    const { showToast } = useToasts();
    const onConnectToSlack = ()=>{
        try {
            connectToSlack({
                board,
                trackLocation: "edit-board-details-modal"
            });
        } catch (_error) {
            showToast("There was an error with slack authentication. Please try again later", {
                timeBeforeAutoDismiss: null,
                type: "assertive",
                withCloseButton: true
            });
        }
    };
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "filled",
        color: "grey",
        size: "extra-large",
        className: "mt-2 w-full justify-start font-normal",
        prefix: /*#__PURE__*/ _jsx(SlackIcon, {
            className: "size-4"
        }),
        onClick: onConnectToSlack,
        children: "Connect to Slack"
    });
});
ConnectToSlack.displayName = "ConnectToSlack";
